export default "__VITE_ASSET__BJ69WYDI__";